/** React Query cache namespace. One cache entry per document type — see `index.tsx`. */
export const SUBCONTRACTOR_DOCUMENTS_ENTITY_KEY = 'subcontractor-documents';
/** Locale namespace for this surface's table copy. */
export const SUBCONTRACTOR_DOCUMENTS_NS = 'features.subcontractor_documents.table';
/**
 * Sibling of the table namespace, not a child — the same layout every other converted surface
 * uses. Deriving it from `SUBCONTRACTOR_DOCUMENTS_NS` produced a `[missing "en...."]` toast on
 * Building, which jest cannot catch because it mocks `translate` to echo its namespace.
 */
export const PROGRESS_TOAST_NS = 'features.subcontractor_documents.progress_toast';
export const UPLOAD_NS = 'features.subcontractor_documents.upload';
export const MASS_ACTIONS_NS = 'features.subcontractor_documents.mass_actions';
// `features.commons`, matching the other four converted surfaces -- NOT `commons`, which resolves
// to nothing and renders a literal `[missing "en.commons.cancel"]` button. No unit test can catch
// that: jest mocks `translate` to echo its key, so a dead namespace still reads as a plausible
// string. `scripts/check-frontend-i18n.rb` (CI job `frontend-i18n-parity`) is the guard.
export const COMMONS_NS = 'features.commons';
/**
 * `subcontractor_documents` has no `name` column. The legacy screen has always shown the raw
 * filename and offers no rename, so this surface does not either — the Name cell is a link, not
 * an editor, and there is no `update` endpoint.
 */
export const SUPPORTS_RENAME = false;
